import type { ShipAttempt, ShipStage } from "../types";

/** A stage a ship attempt entered, when, what it was on there, and how long it lasted. */
export interface StageSpan {
	stage: ShipStage;
	note?: string;
	at: number;
	ms: number;
}

/**
 * An attempt's stages, oldest first (CONTEXT.md "Ship attempt"). Each lasts until the next began;
 * the last until the attempt ended, pushed included, or until `now` while it runs or, pending from
 * before the push lane, waits on the host's deploy.
 */
export function stageSpans(attempt: ShipAttempt, now: number): StageSpan[] {
	const open = attempt.status === "running" || attempt.status === "pending";
	const end = open ? now : attempt.updatedAt;
	return attempt.stages.map((entry, i) => ({
		stage: entry.stage,
		...(entry.note ? { note: entry.note } : {}),
		at: entry.at,
		ms: Math.max(0, (attempt.stages[i + 1]?.at ?? end) - entry.at),
	}));
}
